import { render, staticRenderFns } from "./ConfigurationTipPercentages.vue?vue&type=template&id=7196c2ad&"
import script from "./ConfigurationTipPercentages.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTipPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports